import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import styles from './DeactivateAPIKeyModal.module.scss';
export const GetDeactivateAPIKeyModalTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            DeactivateAPIKeyModalTID: {
                Modal: 'deactivate-api-key-modal',
                Content: 'deactivate-api-key-modal-content',
                Error: 'deactivate-api-key-error'
            }
        }
    });
export const DeactivateAPIKeyModal = (param)=>{
    let { apiKey, dismissModal, refresh } = param;
    const { t: apiKeysPageTexts } = useLocaleKeys('settings.apiKeys');
    const { t: commonTexts } = useLocaleKeys('common');
    const { api } = useStoreActions();
    const overlayContext = useOverlayContext();
    const { DeactivateAPIKeyModalTID } = useMemo(()=>GetDeactivateAPIKeyModalTID(), []);
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'deactivate_a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'deactivate_a_p_i_key_cancel'
            }
        },
        title: apiKeysPageTexts.deactivateTitle(),
        skin: "danger",
        content: /*#__PURE__*/ _jsxs(Typography, {
            className: styles.deactivateApiKeyModalContent,
            testId: DeactivateAPIKeyModalTID.Content(),
            children: [
                apiKeysPageTexts.deactivateContent(),
                " ",
                /*#__PURE__*/ _jsx("br", {}),
                " ",
                /*#__PURE__*/ _jsx("br", {}),
                " ",
                apiKeysPageTexts.deactivateConfirm()
            ]
        }),
        primaryButtonLabel: commonTexts.buttons.deactivateApiKey(),
        onPrimaryButtonClick: async ()=>{
            try {
                await api.business.deactivateAPIKey(apiKey.id);
                await refresh();
            } catch (error) {
                overlayContext.showErrorToast(commonTexts.toasts.failedToDeactivateApiKey(), DeactivateAPIKeyModalTID.Error());
            } finally{
                dismissModal();
            }
        },
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onSecondaryButtonClick: dismissModal,
        testId: DeactivateAPIKeyModalTID.Modal()
    });
};
